import { persistStore, Persistor } from 'redux-persist'

import type { Store } from 'redux'

type AnyStore = Store<unknown>

let persistor: Persistor | null = null

// The persistor handle for the store, available once hydrate() has run.
// Lets callers force pending writes to disk with persistor.flush().
export const getPersistor = (): Persistor | null => persistor

/**
 * Hydrates the redux store from persisted storage.
 * Returns a promise that resolves when hydration is complete.
 */
const hydrate = (store: AnyStore): Promise<void> => {
  return new Promise((resolve) => {
    persistor = persistStore(store, null, () => {
      resolve()
    })
  })
}

export default { hydrate }
